import { User, Phone, ExternalLink } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { ContactInfo } from '../types';

interface ContactContentProps {
  contact: ContactInfo;
  isOutgoing?: boolean;
  className?: string;
}

/**
 * Компонент для отображения контакта в сообщении
 */
export function ContactContent({ contact, isOutgoing, className }: ContactContentProps) {
  const fullName = [contact.firstName, contact.lastName].filter(Boolean).join(' ');

  // Format phone number for display
  const formatPhone = (phone: string) => {
    // Add + if not present
    if (!phone.startsWith('+')) {
      phone = '+' + phone;
    }
    return phone;
  };

  // Create tel: link
  const phoneLink = `tel:${contact.phoneNumber}`;

  return (
    <div className={cn('flex items-center gap-3 py-1', className)}>
      {/* Avatar */}
      <div
        className={cn(
          'w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0',
          isOutgoing ? 'bg-white/20' : 'bg-primary/10'
        )}
      >
        <User className={cn('h-6 w-6', isOutgoing ? 'text-white' : 'text-primary')} />
      </div>

      {/* Contact info */}
      <div className="flex-1 min-w-0">
        <p className="font-medium truncate">{fullName || 'Контакт'}</p>
        <a
          href={phoneLink}
          onClick={(e) => e.stopPropagation()}
          className={cn(
            'text-sm flex items-center gap-1 hover:underline',
            isOutgoing ? 'text-white/80' : 'text-muted-foreground'
          )}
        >
          <Phone className="h-3 w-3" />
          {formatPhone(contact.phoneNumber)}
        </a>
      </div>

      {/* Open contact action */}
      {contact.userId && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            // Можно добавить открытие профиля пользователя
            window.open(`https://t.me/user?id=${contact.userId}`, '_blank');
          }}
          className={cn(
            'p-2 rounded-full transition-colors',
            isOutgoing ? 'hover:bg-white/20' : 'hover:bg-muted'
          )}
          title="Открыть в Telegram"
        >
          <ExternalLink className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
